export default __webpack_public_path__ + "static/williams-7d67244173406cf27851312dca50083e.jpg";